module.exports = __webpack_public_path__ + "static/media/pricing-card.1bf277a6.svg";